import {
  Badge,
  Button,
  Card,
  Empty,
  FloatButton,
  Form,
  Menu,
  Row,
  Space,
  Table,
  TableProps,
} from 'antd';
import Search from 'antd/es/input/Search';
import React from 'react';
import styled from 'styled-components';

export const CopyButton = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  p {
    text-transform: uppercase;
    white-space: nowrap;
    margin: 0;
  }
  path {
    fill: rgba(0, 0, 0, 0.25);
  }
`;

export const FilterIcon = styled.img`
  width: 16px;
  height: 16px;
`;

export const TagWrapper = styled.span`
  display: inline-block;
`;

export const EmptyCustom = styled(Empty)`
  padding: 128px 0;
  h5 {
    margin: 0;
  }
  p {
    margin: 0;
  }
  svg {
    width: 64px;
  }
  .ant-empty-image {
    height: auto;
    margin: 0 0 24px;
  }
`;

export const MenuCustomTable = styled(Menu)`
  @media screen and (max-width: 991px) {
    .ant-menu-title-content,
    .anticon {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85) !important;
    }

    .ant-menu-item-disabled {
      .ant-menu-title-content {
        color: rgba(0, 0, 0, 0.25) !important;
      }
    }
  }
`;

export const SelectedCounter = styled.span`
  display: inline-block;
  font-weight: 500;
  font-size: 12px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.85);
  padding: 0 12px;
  margin: 0 12px;
  border-right: 1px solid var(--neutral-4);
  border-left: 1px solid var(--neutral-4);
  &.mobile-style {
    border: none;
    padding: 0;
    margin: 0;
    margin-left: 35px;
    line-height: 28px;
  }
`;

export const ExpanderContent = styled.div`
  display: none;
  grid-template-columns: repeat(2, 50%);
  padding: 9px;
  font-size: 14px;
  line-height: 14px;
  border-radius: 8px;
  color: rgba(0, 0, 0, 0.45);
  background: #f9f9f9;
  span:nth-child(2) {
    text-align: right;
    color: #000000;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  @media screen and (max-width: 575px) {
    border-radius: 0;
    padding: 9px 16px;

    &.nopadding {
      padding: 9px 0;
    }
  }

  &.show {
    display: grid;
  }
`;

export const HorizontalFiltersContainer = styled.div`
  display: flex;
  margin: 0 0 16px;
  gap: 4px;

  /* PeriodSelector desktop: 32px height, keep current widths */
  @media screen and (min-width: 576px) {
    [data-period-selector] {
      .ant-select-single.ant-select-lg {
        height: 32px !important;
      }
      .ant-select-single.ant-select-lg:not(.ant-select-customize-input):not(.ant-select-customize-input)
        .ant-select-selection-search-input {
        height: 30px;
      }
      .ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector::after,
      .ant-select-single.ant-select-lg:not(.ant-select-customize-input)
        .ant-select-selector
        .ant-select-selection-item,
      .ant-select-single.ant-select-lg:not(.ant-select-customize-input)
        .ant-select-selector
        .ant-select-selection-placeholder {
        line-height: 30px;
      }
      .ant-picker-large {
        height: 32px;
      }
      .ant-picker-large .ant-picker-input > input {
        height: 30px;
      }
      .ant-row {
        height: 32px;
      }
      .ant-btn {
        height: 32px !important;
        line-height: 30px !important;
      }
      .ant-form-item {
        padding-bottom: 0;
        margin-bottom: 0;
      }
    }
  }

  @media screen and (max-width: 575px) {
    /* Default mobile header bar style (kept for legacy areas) */
    flex-direction: row;
    background-color: var(--neutral-14);
    padding: 12px 16px;
    margin: -17px -24px 16px -24px;
    gap: 8px;
    flex-wrap: nowrap;
    align-items: center;
    border-top: 1px solid var(--neutral-14);

    /* PeriodSelector mobile: 100% width, 40px height, stacked layout */
    [data-period-selector] {
      width: 100%;
      flex-direction: column;
      gap: 8px;
    }
    [data-period-selector] .ant-select,
    [data-period-selector] .ant-picker,
    [data-period-selector] .ant-btn {
      width: 100% !important;
      height: 40px !important;
      min-height: 40px !important;
    }
    [data-period-selector] .ant-select .ant-select-selector {
      height: 40px !important;
      line-height: 38px !important;
    }
    [data-period-selector] .ant-picker .ant-picker-input > input {
      height: 38px !important;
      line-height: 38px !important;
    }
    [data-period-selector] .ant-row {
      width: 100%;
      height: 40px;
    }
    [data-period-selector] .ant-form-item {
      width: 100%;
    }

    /* For Inventory HF we want content-area stacked layout */
    &.hf-xs-sm {
      background: transparent;
      padding: 0;
      margin: 0 0 12px 0;
      flex-direction: column;
      align-items: stretch;
      gap: 8px;
      border-top: 0; /* remove dark line above tabs */

      .mobile-filter-full {
        flex: 0 0 33.333%;
        display: flex;
        justify-content: center !important;
        align-items: center;
        text-align: center;
        margin-bottom: 8px;

        .ant-btn-icon {
          margin-right: 4px;
        }
      }

      > .hf-search {
        width: 100%;

        > div {
          display: flex !important;
          width: 100%;
        }
      }

      /* Category select: 40px height, 100% width, same as PeriodSelector on mobile (Costs) */
      .costs-mobile-filters > .ant-row {
        height: 40px !important;
        width: 100%;
        display: flex !important;
        flex-direction: row !important;
        align-items: center;
      }
      .costs-mobile-filters > .ant-row label:empty {
        display: none;
      }
      .costs-mobile-filters > .ant-row .ant-select {
        width: 100% !important;
        height: 40px !important;
        min-height: 40px !important;
      }
      .costs-mobile-filters > .ant-row .ant-select .ant-select-selector {
        height: 40px !important;
        line-height: 38px !important;
      }
      .costs-mobile-filters > .ant-row .ant-form-item {
        flex: 1;
        min-width: 0;
        padding-bottom: 0 !important;
        margin-bottom: 8px !important;
      }
      .costs-mobile-filters > .ant-row .ant-form-item .ant-form-item-control {
        padding-bottom: 0 !important;
        margin-bottom: 8px !important;
      }
    }
  }

  /* Desktop: >= 992px keeps current layout */
  &.hf-desktop {
    flex-wrap: nowrap;

    .hf-filter-container {
      display: flex;
      align-items: center;
      gap: 6px;

      /* Align all filter elements (Category select, etc.) with PeriodSelector - 32px height */
      > .ant-row {
        height: 32px;
        display: flex;
        align-items: center;
        margin: 0;
      }
      > .ant-row .ant-form-item {
        margin: 0;
      }
      > .ant-row .ant-select {
        height: 32px !important;
      }
      > .ant-row .ant-select .ant-select-selector {
        height: 32px !important;
        line-height: 30px !important;
      }
      > .ant-row label:empty {
        display: none;
      }

      .hf-search {
        min-width: 280px;
      }
    }
  }

  /* md–lg: 768–991px. Tabs, then Filters button, then search aligned right */
  @media screen and (min-width: 768px) and (max-width: 991px) {
    &.hf-md-lg {
      flex-wrap: nowrap;
      align-items: center;

      .hf-filter-container {
        display: flex;
        align-items: center;

        > .ant-row {
          height: 32px;
          display: flex;
          align-items: center;
          margin: 0;
        }
        > .ant-row .ant-form-item {
          margin: 0;
        }
        > .ant-row .ant-select {
          height: 32px !important;
        }
        > .ant-row .ant-select .ant-select-selector {
          height: 32px !important;
          line-height: 30px !important;
        }
        > .ant-row label:empty {
          display: none;
        }

        .hf-sep {
          margin-right: 6px;
        }
      }

      .hf-search {
        flex: 1;
        min-width: 0;
      }
    }
  }

  /* sm–md: 576–767px. Tabs full-width, Filters at end of first row, Search full-width below */
  @media screen and (min-width: 576px) and (max-width: 767px) {
    &.hf-sm-md {
      flex-wrap: wrap;
      row-gap: 8px;
      gap: 4px;

      /* First row: 75% for status, 25% for separator+Filters */
      display: grid;
      grid-template-columns: 75% 25%;
      grid-auto-flow: row;

      .hf-status {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 4px;
      }

      .hf-filter-container {
        display: flex;
        align-items: center;
        gap: 0;

        > .ant-row {
          height: 32px;
          display: flex;
          align-items: center;
          margin: 0;
        }
        > .ant-row .ant-form-item {
          margin: 0;
        }
        > .ant-row .ant-select {
          height: 32px !important;
        }
        > .ant-row .ant-select .ant-select-selector {
          height: 32px !important;
          line-height: 30px !important;
        }
        > .ant-row label:empty {
          display: none;
        }

        .hf-sep {
          display: block;
          flex-shrink: 0;
          margin-right: 6px;
        }

        .desktop-filter-button {
          flex: 1;
        }
      }

      .hf-search {
        grid-column: 1 / -1;
        > div {
          display: flex;
          width: 100%;
        }
      }
    }
  }

  /* xs–sm: <576px. Mobile: filter icon then search takes the row */
  @media screen and (max-width: 575px) {
    &.hf-xs-sm {
      .hf-search {
        flex: 0 0 auto;
        width: 100%;
      }
      .mobile-filter-full {
        width: 100%;
        justify-content: flex-start;
        margin-bottom: 8px;
      }
    }
  }
`;

export const ScreenContainer = styled.div`
  .flex-center-content {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  @media screen and (max-width: 991px) {
    .ant-btn,
    .ant-input,
    .ant-select-selector,
    .ant-picker {
      height: 40px !important;
      min-height: 40px !important;
    }

    .ant-select-selector {
      line-height: 38px !important;
    }
  }

  .sm-xs-full-width-btn {
    width: 100%;

    .ant-btn,
    .ant-dropdown-trigger {
      width: 100% !important;
      display: block !important;
      height: 28px !important;
      line-height: 26px !important;
      padding: 0 11px !important;
    }

    .ant-btn .anticon {
      margin-right: 8px;
    }
  }
  .text-p {
    line-height: 32px;
    margin: 0;
    font-size: 14px;
  }
  .text-span {
    color: rgba(0, 0, 0, 0.45);
    font-size: 12px;
    font-weight: 400;
    padding-right: 0;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    line-height: 32px;
  }

  .hide-text-action-button {
    button:first-child {
      display: none;
    }
  }

  .dropdowns-container {
    .ant-btn {
      margin-left: 10px;
    }
    &.dropdowns-mobile {
      display: none;
    }
  }

  @media screen and (max-width: 991px) {
    .bulk-actions-mobile,
    .add-action-mobile {
      position: fixed;
      margin: 0;
      top: 17px;
      z-index: 8;
      right: 84px;
      color: var(--neutral-1) !important;
    }
    .add-action-mobile {
      right: 24px;
    }

    .dropdowns-container {
      &.dropdowns-desktop {
        display: none;
      }
      &.dropdowns-mobile {
        display: block;
      }
    }

    .percentage-change.neutral {
      font-weight: 400;
      color: var(--character-secondary);
    }
  }

  &.with-tabs {
    .ant-tabs-nav-wrap {
      border-bottom: 1px solid var(--neutral-5);
    }

    .ant-tabs-tab,
    .ant-tabs-tab-active,
    .ant-tabs-tab + .ant-tabs-tab {
      margin-right: 20px;
    }
  }
`;

export const InfoCardCustom = styled.div``;

export const HeaderCardCustom = styled.div`
  display: flex;
  @media screen and (max-width: 575px) {
    .ant-image {
      width: 56px;
    }
  }
`;

export const ToggleHeaderVehicle = styled.div`
  display: none;
  padding: 0 12px;
  h4,
  p {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 400;
    line-height: 22px;
    margin: 0;
  }
  &.show {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    padding-right: 4px;
  }
`;

export const Expander = styled.section`
  padding: 0 8px 16px;

  ${ExpanderContent} {
    :nth-child(2n) {
      background: transparent;
    }
  }
  @media screen and (max-width: 991px) {
    padding: 0 5px;
  }

  &.form {
    background-color: transparent;

    ${ExpanderContent} {
      background-color: var(--neutral-4);
    }
    ${ExpanderContent} {
      :nth-child(2n) {
        background: none;
      }
    }
  }
`;

export const TableSkeleton = styled.section`
  border: 1px solid var(--neutral-4);
  box-shadow: 0px 0px 8px rgb(0, 0, 0, 0.06);
  border-radius: 4px;
  overflow: hidden;
  padding: 16px;
  background: #ffffff;
  margin-top: 24px;
`;

export const HeaderModalCustom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  .anticon-close {
    color: rgba(0, 0, 0, 0.25);
  }
  h3 {
    margin: 0;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: rgba(0, 0, 0, 0.85);
    .anticon {
      margin-right: 12px;
    }
    & + h3 {
      color: rgba(0, 0, 0, 0.45);
    }
  }
`;

export const ModalButtonsContainer = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
`;

export const AvatarCustom = styled.img`
  width: 32px;
  height: 32px;
  object-fit: cover;
  border-radius: 4px;
`;

export const CreatingBadge = (props: any) => {
  return (
    <Badge
      count={props.count}
      style={{ margin: '0 4px 0 0', backgroundColor: props.active ? '#12DFA9' : '#D9D9D9' }}
    />
  );
};

export const EditBlockHeader = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 50px;

  h4 {
    margin-left: 10px;
    margin-bottom: 0;
  }
`;

export const SectionHeader = styled(EditBlockHeader)`
  max-width: 520px;
  margin-bottom: 0;
  justify-content: space-between;

  div {
    display: flex;
  }

  .ant-skeleton {
    margin-top: -6px;
    float: left;
  }
`;

export const LargeSearch = styled(Search)`
  width: 250px;
  margin-bottom: 25px;

  .ant-input-wrapper.ant-input-group {
    display: flex;
    flex-direction: row-reverse;
  }

  .ant-input-group .ant-input-group-addon {
    width: 0;
  }

  .ant-input-group input,
  .ant-input-group > .ant-input:first-child,
  .ant-input-group .ant-input-group-addon:first-child {
    height: 32px;
    padding-left: 35px;
    border-bottom-right-radius: 4px;
    border-top-right-radius: 4px;
    border-end-end-radius: 4px;
    border-start-end-radius: 4px;
    font-size: 14px;

    &:hover {
      border-color: var(--primary-8);
    }

    &:focus {
      border-color: var(--primary-8);
      box-shadow: rgb(0, 0, 0, 0.5) 0px 0px 2px;
    }
  }

  .ant-input-group-addon {
    position: relative;
    z-index: 2;

    button {
      background: transparent;
      border: none;
      padding-left: 5px;
      margin-top: 1px;
      margin-left: 3px;
      height: 30px;

      &:hover {
        color: var(--primary-8) !important;
        background-color: transparent !important;
      }
    }
  }
`;

export const WidgetsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 4px;
  margin-bottom: 25px;

  &.with-filters-bar {
    margin-bottom: 8px;
  }

  /* MD: 768-991px - 3 boxes per line */
  @media screen and (min-width: 768px) and (max-width: 991px) {
    flex-wrap: wrap;

    .filter-box {
      width: calc(33.333% - 3px) !important;

      .filter-box-header {
        h4,
        h3 {
          font-size: 14px !important;
        }
      }
    }
  }

  /* SM: 576-767px - 2 boxes per line */
  @media screen and (min-width: 576px) and (max-width: 767px) {
    flex-wrap: wrap;

    .filter-box {
      width: calc(50% - 2px) !important;

      .filter-box-header {
        h4,
        h3 {
          font-size: 14px !important;
        }
      }
    }
  }

  /* XS: <576px - default 50% width */
  @media screen and (max-width: 575px) {
    flex-wrap: wrap;
    gap: 4px;

    .filter-box {
      width: calc(50% - 2px) !important;
      margin-bottom: 0;

      .ant-card-body {
        padding: 8px;
      }

      .filter-box-header {
        h4,
        h3 {
          font-size: 14px !important;
        }
      }
    }
  }

  /* Deals and Costs: 100% width on mobile only */
  &.deals-filter-boxes,
  &.expenses-filter-boxes {
    @media screen and (max-width: 767px) {
      flex-wrap: wrap;

      .filter-box {
        width: 100% !important;
      }
    }
  }
`;

export const Widget = styled(Card)`
  display: flex;
  cursor: pointer;
  background-color: var(--neutral-1);
  height: 60px;
  border: 1px solid var(--neutral-4);
  border-radius: 4px;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease;

  &:hover {
    background-color: var(--neutral-16);
    border-color: var(--neutral-5);
  }

  h4 {
    margin-bottom: 0;
    font-size: 16px !important;
    font-weight: 400;
    line-height: 20px;
  }

  &.no-filter {
    cursor: initial;
    pointer-events: none;
  }

  &.non-clickable {
    cursor: default;

    &:hover {
      background-color: var(--neutral-1);
      border-color: var(--neutral-4);
    }
  }

  &.active {
    background-color: var(--neutral-250);
    color: var(--neutral-1);
  }

  .ant-card-body {
    padding: 10px 12px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    row-gap: 4px; /* increase spacing between title and count */
  }

  .filter-box-header {
    display: flex;
    gap: 4px;
    align-items: center;
    margin-bottom: 0;
    min-width: 0;

    h4 {
      margin: 0;
      font-weight: 400;
      font-size: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      min-width: 0;
    }

    h3 {
      margin: 0;
      font-weight: 400;
      font-size: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      min-width: 0;
    }
  }

  .filter-box-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;

    .prev-month-text {
      color: var(--character-primary);
      font-weight: 300;
    }

    .percentage-change {
      display: flex;
      align-items: center;
      gap: 4px;
      margin-left: auto;

      .dot {
        font-size: 10px;
        line-height: 1;

        &.positive {
          background-color: var(--character-success-dark);
          color: var(--neutral-1);
          border-radius: 50%;
          padding: 2px 3px;
        }

        &.negative {
          background-color: var(--character-danger-dark);
          color: var(--neutral-1);
          border-radius: 50%;
          padding: 2px 3px;
        }
      }

      .neutral-icon {
        width: 18px;
        height: 18px;
        box-shadow: none;
        margin-top: 1px;
      }
    }
  }

  .filter-box-details {
    p {
      font-size: 14px;
      margin-bottom: 4px;
      color: var(--neutral-7);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &.deal-info-box {
    /* Taller card for 3-line layout in Edit Deal */
    height: 88px;
    .filter-box-header {
      margin-bottom: 0;
    }

    .filter-box-details {
      p {
        margin-bottom: 0;
        color: var(--character-primary);
        font-weight: 300;
        line-height: 18px;
      }
      /* Add spacing between detail lines (2nd and 3rd lines) */
      p + p {
        margin-top: 5px;
      }
    }

    .ant-card-body {
      height: 100%;
      box-sizing: border-box;
      row-gap: 5px; /* space between title and detail lines */
    }
  }

  &.inventory-filter-box {
    position: relative;

    .filter-close-icon {
      position: absolute;
      top: 8px;
      right: 8px;
      font-size: 16px;
      color: var(--neutral-6);
      cursor: pointer;
      z-index: 1;
      transition: opacity 0.2s;

      &:hover {
        opacity: 0.8;
      }
    }
  }

  /* Improve contrast for dark (active) cards */
  &.active {
    .filter-close-icon {
      color: var(--neutral-1);
    }
    p {
      color: var(--neutral-1);
      opacity: 0.9;
    }
    .prev-month-text {
      color: var(--neutral-1);
      opacity: 0.9;
    }
  }

  p {
    font-size: 14px !important;
    margin-bottom: 0;
    font-weight: 300;
    line-height: 16px;
  }
`;

export const CustomSpace = styled(Space)`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const DescriptionWithMenu = styled.div`
  display: flex;
  flex-direction: column;

  button {
    margin-bottom: 10px;
  }
`;

export const FormWithBigItems = styled(Form)`
  .ant-form-item {
    max-width: 100%;
  }
`;

export const StyledFloatButton = styled(FloatButton)`
  .ant-float-btn-body,
  .ant-float-btn-body:hover {
    background-color: #ff4d4f;
  }

  .anticon {
    color: #fff;
  }
`;

export const StyledAntTable = styled(Table)<any>`
  .ant-table-container {
    margin-top: 16px;
    border: 1px solid var(--neutral-5);
    border-radius: 4px;
  }

  @media screen and (max-width: 991px) {
    .ant-table-container {
      overflow-x: auto;
    }
  }

  .ant-table-thead > tr > th {
    background-color: var(--neutral-16);
    border-bottom: 1px solid var(--neutral-5);
    text-transform: uppercase;
    font-weight: 500;
    line-height: 32px;
    font-size: 10px;
    padding: 0 12px;
    white-space: nowrap;
  }
  .ant-table-column-title {
    font-size: 10px;
    white-space: nowrap;
  }

  .ant-table-ping-right .ant-table-cell-fix-right-first {
    border-left: 1px solid var(--neutral-5);
  }
  .ant-table-ping-right .ant-table-cell-fix-right-first::after,
  .ant-table-ping-left .ant-table-cell-fix-left-last::after {
    display: none;
  }

  .ant-table-selection-column {
    text-align: center !important;
  }

  .ant-table-tbody > tr > td {
    padding: 8px 12px;

    &.thumb {
      padding: 8px 0;
    }

    &.text-center {
      text-align: center;
    }
    &.text-right {
      text-align: right;
      /* Ensure inner InputNumber input aligns right too */
      .ant-input-number-input {
        text-align: right;
      }
    }
  }

  .ant-table-thead > tr > th.text-right {
    text-align: right;
  }

  .ant-table-tbody > tr > td:not(.col-actions) {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .ant-table-tbody > tr.ant-table-row:nth-child(even) {
    background: var(--neutral-280);
    .ant-table-cell-fix-left,
    .ant-table-cell-fix-right,
    .ant-table-selection-column {
      background: var(--neutral-280);
    }
  }
  .ant-table-tbody > tr.ant-table-row:nth-child(odd) {
    background: var(--neutral-16);

    .ant-table-cell-fix-left,
    .ant-table-cell-fix-right,
    .ant-table-selection-column {
      background: var(--neutral-16);
    }
  }

  .ant-image-img.image-table {
    width: 48px;
    height: 48px;
    object-fit: cover;
    border-radius: 4px;
    display: block;
  }

  .ant-pagination-total-text {
    strong {
      font-weight: 600;
    }
  }

  .status-dot {
    width: 10px;
    height: 10px;
    background-color: #20b2aa;
    border-radius: 50%;
    display: inline-block;
    margin-right: 8px;

    &.danger {
      background-color: #ff4d4f;
    }
    &.warning {
      background-color: #faad14;
    }
    &.success {
      background-color: #52c41a;
    }
    &.neutral {
      background-color: var(--neutral-6);
    }
  }

  .table-actions {
    &.mobile {
      display: none;
    }
  }

  .ant-form-item {
    padding-bottom: 0;
  }

  @media screen and (max-width: 767px) {
    .table-actions {
      &.mobile {
        display: inline-block;
      }
      &.desktop {
        display: none;
      }
    }
  }

  .ant-pagination-item,
  .ant-pagination .ant-pagination-prev .ant-pagination-item-link,
  .ant-pagination .ant-pagination-next .ant-pagination-item-link {
    background-color: var(--neutral-270);
    &.ant-pagination-item-active {
      background-color: var(--neutral-250);
      border-color: var(--neutral-250);
      a {
        color: var(--neutral-1);
      }
    }
  }
`;

export function StyledTable<T extends object>(props: TableProps<T>) {
  return <StyledAntTable {...props} />;
}

export const FilterSeparator = styled.div`
  width: 1px;
  height: 32px;
  background-color: rgba(0, 0, 0, 0.15);
  align-self: center;

  @media screen and (max-width: 575px) {
    display: none;
  }
`;

export const DarkButton = styled(Button)`
  background-color: #2b2c2c !important;
  color: #f7f8f7 !important;
  border-color: #2b2c2c !important;

  &:hover {
    background-color: #595b5b !important;
    color: #f7f8f7 !important;
    border-color: #595b5b !important;
  }

  &:active {
    background-color: #4d4e4e !important;
    color: #f7f8f7 !important;
    border-color: #4d4e4e !important;
  }

  &:focus {
    border-color: #8be4e4 !important;
    background-color: #2b2c2c !important;
    color: #f7f8f7 !important;
  }

  &:disabled,
  &[disabled] {
    background-color: #f1f2f1 !important;
    color: #b2b4b4 !important;
    border-color: #f1f2f1 !important;

    .ant-btn-icon,
    .anticon,
    span[role='img'],
    svg {
      color: #b2b4b4 !important;
    }

    .anticon svg,
    .anticon svg path,
    svg,
    svg path {
      fill: #b2b4b4 !important;
      color: #b2b4b4 !important;
    }

    img {
      opacity: 0.65;
      filter: grayscale(100%) brightness(0.8);
    }

    span[aria-hidden='true'] {
      background-color: #b2b4b4 !important;
    }
  }

  &.mobile-filter-button {
    display: none;
  }

  &.desktop-filter-button {
    display: inline-flex;
  }

  @media screen and (max-width: 575px) {
    &.mobile-filter-button {
      display: inline-flex !important;
      width: 100% !important;
      background-color: #3d3e3e !important;
      color: #ffffff !important;
      border: none !important;
      padding: 8px 12px !important;
      flex-shrink: 0;
      min-width: auto !important;

      .anticon {
        font-size: 18px;
      }

      .anticon svg,
      .anticon svg path {
        color: #fff !important;
        fill: #fff !important;
      }
    }

    &.desktop-filter-button {
      display: none !important;
    }
  }
`;

export const TableTopActions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  /* Pull up to align with section headers like "Products" */
  margin-top: -50px;
`;

export const StyledFilters = styled(Row)`
  margin-top: 10px;
  margin-bottom: 0px;

  @media screen and (max-width: 575px) {
    &.analytics-filters .analytics-domains-col .ant-form-item,
    &.analytics-filters .analytics-domains-col .ant-form-item .ant-form-item-control {
      padding-bottom: 0 !important;
      margin-bottom: 8px !important;
    }
  }

  .ant-select-selector {
    min-width: 150px;
    height: 35px !important;

    .ant-select-selection-overflow {
      margin-top: -4px;
    }
  }

  .ant-select-multiple.ant-select-lg .ant-select-selection-item {
    height: 25px;
    line-height: 20px;
  }

  .ant-btn {
    height: 35px;
  }
`;
